module.exports = __webpack_public_path__ + "static/media/call-icon.dffe4d54.svg";